
import React, { useRef, useState , useEffect} from 'react'
import Navbar from '../../Components/Navbar/Navbar'
import './PostAd.css'
import Footer from '../../Components/Footer/Footer';

import  userApi from '../../Common/Api/UserApi.js'
import Cookies from 'universal-cookie';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
 

export default function PostAd() {

    const cookies = new Cookies();
    const [show1,setShow1] = useState(true);
    const navigate = useNavigate();

    const {BookWormUser} =useSelector((state)=>state)
    const {userInfo} = BookWormUser;

    const [user,setUser] = useState({name:userInfo.name,email:userInfo.email,contact:userInfo.contact,location:""});

    const [book,setBook] = useState({title:"",images:[],price:"",edition:"",damage:"",totalPages:"",pagesMarked:"",authors:""});
    
    const [showText,setShowText] = useState(true);



    const changeUser = (e)=>{
        setUser({...user, [e.target.name] : e.target.value});
    }
    const changeBook = (e)=>{
        setBook({...book, [e.target.name] : e.target.value});
    }

    const imageRef = useRef();

    const onImageChange = (e) => {
       
        e.preventDefault()
        if (e.target.files.length) {
        
            let imageArr = book.images;
            imageArr = [...imageArr,...e.target.files]

            setBook({...book, images:imageArr});
            setShowText(!(book.images.length>0));
           
        }

    }

    const removeImg = (image)=>{
        let imageArr=[];
        imageArr = book.images.filter((item)=>item!==image)
        setBook({...book,images:imageArr});

        setShowText(!(book.images.length>0));
        var e = window.event;
       
       
        e.stopPropagation();
    }
    
    const handleSubmit1= (e)=>{
        e.preventDefault();

        if(!user.name.length || !user.email.length || !user.contact || !user.location.length )
        {
            alert("Please Fill Complete Details !");
            return;
        }
        setShow1(false);
    }

    const back = (e) =>{
        e.preventDefault();
        setShow1(true);
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        if(book.images.length<5)
        {
            alert('Please Provide 5 photos of the book !');
            return;
        }
        if(book.images.length>5)
        {
            alert('Please Provide only 5 photos of the book !');
            return;
        }

        if(!book.title.length || !book.authors.length || !book.price.length || !book.edition.length || !book.totalPages.length || !book.pagesMarked.length){
            
            alert("Please Fill Complete Details !");
        }

        const data = new FormData();
        for(var x = 0; x<book.images.length; x++) {
            data.append('images', book.images[x])
        }
        data.append('username',user.name);
        data.append('email',user.email);
        data.append('contact',user.contact);
        data.append('location',user.location);
        data.append('title',book.title);
        data.append('authors', book.authors.split(','));
        data.append('price',book.price);
        data.append('edition',book.edition);
        data.append('damage',book.damage);
        data.append('totalPages',book.totalPages);
        data.append('markedPages',book.pagesMarked);
        
        console.log(cookies.get('token'));
        const res = await userApi.post('/create-ad',data,{
            headers: {
                'Authorization':`Bearer ${cookies.get('token')}`,
             }
        });
        console.log(res);
        alert("Your AD is sent to Admin for Review");
        navigate("/")
    }

  return (
      <div className='postad' >
          <Navbar colorLeft="#fae5df" colorRight="#fae5df" />
          <div className='postad-container'>

            
            <div className={(show1)?'ad-form-first show':'ad-form-first'}>
              
              <form onSubmit={handleSubmit1}>
                <div className='ad-form-comp'>
                    <label className='step'>Post a Free AD for your Book !</label>
                    
                </div>
                <div className='ad-form-comp'>
                    <label className='step'>Step - 1</label>
                </div>
                <div className='ad-form-comp'>
                    <label>Name</label>
                    <input type="text" className='ad-input' name='name' onChange={changeUser} value={user.name} required={true}/>
                </div>
                <div className='ad-form-comp'>
                    <label>Email</label>
                    <input type="text" className='ad-input' name='email' onChange={changeUser} value={user.email} required={true}/>
                </div>
                <div className='ad-form-comp'>
                    <label>Contact</label>
                    <input type="text" className='ad-input' name='contact' onChange={changeUser} value={user.contact} required={true} minLength='10' maxLength={10}/>
                </div>
                <div className='ad-form-comp'>
                    <label>Location</label>
                    <input type="text" className='ad-input' name='location' onChange={changeUser} value={user.location} required={true}/>
                </div>
                <div className='ad-form-comp'>
                    <button type='submit' className='form-btn'>Submit</button>
                </div>
              </form>
            </div>

            <div className={(show1)?'ad-form-second':'ad-form-first show'}>
                <form onSubmit={handleSubmit}>
                  <div className='ad-form-comp'>
                  <div className='step' onClick={back} style={{cursor:"pointer"}}><i className="fa-solid fa-arrow-left-long"></i>  Back</div>
                  </div>
                  <div className='ad-form-comp'>
                      <label className='step'>Post a Free AD for your Book !</label>
                  </div>
                  <div className='ad-form-comp'>
                      <label className='step'>Step - 2</label>
                  </div>
                  <div className='ad-form-comp'>
                      <label>Title of the Book</label>
                      <input type='text' className='ad-input' name='title' onChange={changeBook} value={book.title} required={true}></input>
                  </div>
                  <div className='ad-form-comp'>
                      <label>Author of the Book</label>
                      <input type='text' className='ad-input' name='authors' onChange={changeBook} value={book.authors} required={true}></input>
                  </div>
                  

                  <div className='ad-form-comp'>
                      <label>Add Images of Book  (Exact 5)</label>
                        <input type="file" id="add-single-img" accept="image/jpeg" multiple className='img-input' onChange={onImageChange} ref={imageRef} required={true} max={5}/>
                      
                       <div id="input-img-container"  onClick={() => imageRef.current.click() }>
                            
                            <div className={(showText)?'image-input-text show':'image-input-text'}>+ Add photos</div>
                            { book.images.map((element)=>{
                            return(
                                <div className='preview-img-cont' key={element.lastModified}>
                                    <i className="fa-regular fa-circle-xmark remove-img" onClick={()=>removeImg(element)}></i>
                                    <img src={ URL.createObjectURL(element)} alt="Preview" className='preview-img' />
                                </div>
                            )
                            })} 
                            
                      </div>
                  </div>
                  <div className='ad-form-comp'>
                      <label>Price (On the Book)</label>
                      <input type='number' className='ad-input' name='price' onChange={changeBook} value={book.price} required={true}></input>
                  </div>
                  <div className='ad-form-comp'>
                      <label>Book Edition</label>
                      <input type='number' className='ad-input' name='edition' onChange={changeBook} value={book.edition} required={true}></input>
                  </div>
                  <div className='ad-form-comp damage-book'>
                      <label>Damage on the book</label>
                      <input type="range" min="0" max="100" step="10" className='ad-input' name='damage' onChange={changeBook} value={book.damage} required={true}/>
                      <div className='range-num-left'>0%</div>
                      <div className='range-num-right'>100%</div>
                  </div>
                  <div className='ad-form-comp'>
                      <label>Pages with Markings on them</label>
                      <input type="number" className='ad-input' name='pagesMarked' onChange={changeBook} value={book.pagesMarked} required={true}/>
                  </div>
                  <div className='ad-form-comp'>
                      <label>Total Pages</label>
                      <input type="number" className='ad-input' name='totalPages' onChange={changeBook} value={book.totalPages} required={true}/>
                  </div>
                  
                  <div className='ad-form-comp'>
                      <button type='submit' className='form-btn'>Submit</button>
                  </div>

                </form>
              </div>
          </div>
          <hr style={{ width: "90%", margin: "2rem auto", color: "#fae5df",opacity:".60"}} />
          <Footer/>
      </div>
  )
}
